import {RestResource} from '../rest'

import {ORGANIZATION_SERVER} from '../server'

const person = new RestResource({server: ORGANIZATION_SERVER, resource: 'person'});

export default person;